import React from 'react';

const expertise = [
  { icon: '🌐', title: 'Web Technologies', desc: 'React, Angular, Vue, Node.js, PHP, WordPress, Magento' },
  { icon: '📱', title: 'Mobile Development', desc: 'iOS, Android, React Native, Flutter cross-platform apps' },
  { icon: '☁️', title: 'Cloud Services', desc: 'AWS, Azure, Google Cloud, DevOps, CI/CD pipelines' },
  { icon: '🗄️', title: 'Database Management', desc: 'MySQL, PostgreSQL, MongoDB, Oracle, SQL Server' },
  { icon: '🔒', title: 'Cybersecurity', desc: 'Penetration testing, security audits, compliance' },
  { icon: '🧠', title: 'Artificial Intelligence', desc: 'ML models, NLP, computer vision, AI automation' },
  { icon: '📈', title: 'Digital Marketing', desc: 'SEO, SEM, social media, content marketing' },
  { icon: '🏥', title: 'Healthcare IT', desc: 'EMR, HIPAA compliance, medical billing systems' },
];

const Expertise = () => (
  <>
    <section className="py-5 text-white text-center" style={{ background: 'linear-gradient(135deg, #002868, #1a56db)' }}>
      <div className="container py-4">
        <h1 className="fw-bold">Our Expertise</h1>
        <p className="lead" style={{ color: '#cbd5e1' }}>Deep technical knowledge across all domains</p>
      </div>
    </section>

    <section className="py-5 bg-light">
      <div className="container py-4">
        <div className="row g-4">
          {expertise.map((e, i) => (
            <div key={i} className="col-12 col-sm-6 col-lg-3">
              <div className="card border-0 shadow-sm h-100 p-3 text-center">
                <div style={{ fontSize: 40 }} className="mb-3">{e.icon}</div>
                <h6 className="fw-bold">{e.title}</h6>
                <p className="text-muted small">{e.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  </>
);

export default Expertise;
